export const allRunbooks = (state) => state.runbooks.get("runbooks");
export const runbooksPagination = (state) => state.runbooks.get("runbooksPagination");
export const runbooksPageLoading = (state) => state.runbooks.get("pageLoading");
export const runbookLoading = (state) => state.runbooks.get("runbookLoading");
export const runbookDetail = (state) => state.runbooks.get("runbookDetail");
export const runbookDetailLoading = (state) => state.runbooks.get("runbookDetailLoading");
export const runbookActionDetail = (state) => state.runbooks.get("runbookActionDetail");
export const runbookActionDetailLoading = (state) => state.runbooks.get("runbookActionDetailLoading");
export const runbooksError = (state) => state.runbooks.get("error");
